/* ============================================================
   Theme JS — real Shopify cart (AJAX API) + UI behaviors.
   Icons are server-rendered (snippets/icon-sprite.liquid).
   ============================================================ */
(function () {
  "use strict";
  /* Shopify's `t` filter HTML-escapes its output, so strings that intentionally carry
     markup (e.g. "…<b>free shipping</b>") arrive as &lt;b&gt; and would render as visible
     tags when injected via innerHTML. Decode once here, at the boundary. */
  const I18N = (() => {
    try {
      const raw = JSON.parse(document.getElementById("snoutsieI18n").textContent) || {};
      const ta = document.createElement("textarea");
      const decode = (s) => { ta.innerHTML = s; return ta.value; };
      Object.keys(raw).forEach((k) => { if (typeof raw[k] === "string") raw[k] = decode(raw[k]); });
      return raw;
    } catch (_) { return {}; }
  })();
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const ic = (name) => `<svg class="ic" aria-hidden="true"><use href="#ic-${name}"></use></svg>`;
  let CURRENCY = (window.theme && window.theme.currency) || "USD";
  /* Format against the PAGE's language, not the visitor's browser locale: a Polish
     page read in an en-US browser must still show "105,00 zł", not "PLN 105.00". */
  const MONEY_LOCALE = document.documentElement.lang || undefined;
  const money = (cents) => new Intl.NumberFormat(MONEY_LOCALE, { style: "currency", currency: CURRENCY }).format((cents || 0) / 100);
  const FREE_SHIP = (window.theme && window.theme.freeShipThreshold) || 4900;

  /* curated product->complements map (snippets/overlays.liquid) for the
     contextual upsell + the cart cross-sell fallback on a cold-start store */
  let PAIRS = {};
  try { PAIRS = JSON.parse(document.getElementById("snoutsiePairs").textContent); } catch (e) { PAIRS = {}; }
  let adding = false; /* in-flight lock so a fast double-tap can't add qty 2 */

  /* ---------- STAR RATINGS (sprite already in DOM) ---------- */
  $$(".stars").forEach((el) => {
    const n = Number(el.dataset.rating || 5);
    el.innerHTML = Array.from({ length: 5 }, () => ic("star")).join("");
    el.dataset.filled = n;
    el.setAttribute("aria-hidden", "true"); /* decorative — rating is in adjacent text */
  });

  /* ---------- ANNOUNCEMENT SLIDER ---------- */
  const annTrack = $("#annTrack");
  if (annTrack) {
    const slides = $$(".announce__slide", annTrack).length;
    if (slides > 1) {
      let i = 0, timer;
      const go = (n) => { i = (n + slides) % slides; annTrack.style.transform = `translateX(${-i * 100}%)`; };
      const play = () => (timer = setInterval(() => go(i + 1), 7000));
      const stop = () => clearInterval(timer);
      $$("[data-ann]").forEach((b) => b.addEventListener("click", () => { stop(); go(i + Number(b.dataset.ann)); play(); }));
      play();
    }
  }

  /* ---------- MOBILE MENU ---------- */
  const scrim = $("#scrim"), mobileMenu = $("#mobileMenu");
  const openMenu = () => { mobileMenu && mobileMenu.classList.add("open"); scrim && scrim.classList.add("open"); document.body.style.overflow = "hidden"; };
  const closeMenu = () => { mobileMenu && mobileMenu.classList.remove("open"); scrim && scrim.classList.remove("open"); document.body.style.overflow = ""; };
  $("#openMenu")?.addEventListener("click", openMenu);
  $("#closeMenu")?.addEventListener("click", closeMenu);
  scrim?.addEventListener("click", closeMenu);
  $$(".mm-close").forEach((a) => a.addEventListener("click", closeMenu));
  $$("[data-mm-toggle]").forEach((btn) => btn.addEventListener("click", () => {
    const open = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", String(!open));
    btn.nextElementSibling.classList.toggle("open");
  }));

  /* ---------- BUY BOX (plan / qty / bump) — one controller per instance ----------
     A page may legitimately host more than one buy box (e.g. the homepage featured
     box plus a product section, or a duplicated section). Each .js-product-form is
     wired independently and ALL of its lookups are scoped to its own .buy container,
     so two boxes never read or write each other's plan / qty / bump / hidden inputs.
     The contextual upsell uses each box's own data-product-id. */
  /* legacy global sticky bar removed — product pages use snippets/sticky-atc.liquid (.satc) */

  function planUnitPrice(plan) {
    const el = plan && plan.querySelector(".plan__price");
    if (!el) return "";
    const clone = el.cloneNode(true);
    clone.querySelectorAll("s").forEach((s) => s.remove());
    return clone.textContent.trim();
  }

  function initBuyBox(form, isPrimary) {
    const box = form.closest(".buy") || form; /* scope every lookup to this instance */
    /* All hooks are class / name selectors (NOT ids): a page may hold two buy boxes, and a
       scoped el.querySelector('#dupId') is unreliable when the id is duplicated (engines
       optimize id selectors via getElementById → first match document-wide). */
    const planInput = form.querySelector('[name="selling_plan"]');
    const atcPrice = box.querySelector(".js-atc-price");
    const qtyVal = box.querySelector(".js-qty-val"), qtyInput = form.querySelector('[name="quantity"]');
    let qty = 1;

    /* ATC total = selected plan's unit price × qty (+ the add-on if ticked). Prices are cents (data-price). */
    function syncPrice() {
      const sel = box.querySelector(".plan.selected");
      const unit = sel ? parseInt(sel.dataset.price || "0", 10) : 0;
      if (!unit) { const p = planUnitPrice(sel); if (atcPrice && p) atcPrice.textContent = p; return; }
      let total = unit * qty;
      const bumpEl = box.querySelector(".js-bump");
      if (bumpEl && bumpEl.checked) total += parseInt(bumpEl.dataset.price || "0", 10);
      if (atcPrice) atcPrice.textContent = money(total);
    }
    $$(".plan", box).forEach((plan) => plan.addEventListener("click", () => {
      $$(".plan", box).forEach((p) => p.classList.remove("selected"));
      plan.classList.add("selected");
      const radio = plan.querySelector("input[type=radio]"); if (radio) radio.checked = true;
      if (planInput) planInput.value = plan.dataset.sellingPlan || "";
      syncPrice();
    }));
    $$("[data-qty]", box).forEach((b) => b.addEventListener("click", () => {
      qty = Math.max(1, qty + Number(b.dataset.qty));
      if (qtyVal) qtyVal.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      const note = box.querySelector(".js-dog-note");
      if (note) note.textContent = `${qty} tub${qty > 1 ? "s" : ""} is about a ${qty * 30} day supply for one dog`;
      syncPrice();
    }));
    box.querySelector(".js-bump")?.addEventListener("change", syncPrice);
    syncPrice();

    async function addMain() {
      if (adding) return; adding = true;
      try {
        const variantId = form.querySelector('[name="id"]').value;
        const q = parseInt((qtyInput && qtyInput.value) || "1", 10);
        const plan = planInput ? planInput.value : "";
        const items = [plan ? { id: variantId, quantity: q, selling_plan: plan } : { id: variantId, quantity: q }];
        const bump = box.querySelector(".js-bump");
        if (bump && bump.checked && bump.dataset.variantId) items.push({ id: bump.dataset.variantId, quantity: 1 });
        const res = await addItems(items);
        if (!res) return;
        const cart = await getCart();
        renderCart(cart);
        const atcBtn = box.querySelector(".js-atc-btn");
        const mainPid = parseInt(box.dataset.productId || (atcBtn && atcBtn.dataset.productId) || "0", 10);
        showUpsell(mainPid, cart);
      } finally { adding = false; }
    }
    form.addEventListener("submit", (e) => { e.preventDefault(); addMain(); });
    return { box, addMain };
  }

  const buyBoxes = $$(".js-product-form").map((form, i) => initBuyBox(form, i === 0));
  /* (legacy global sticky-ATC wiring removed — snippets/sticky-atc.liquid is self-contained) */

  /* ---------- SHOPIFY CART ---------- */
  const cartDrawer = $("#cartDrawer"), cartScrim = $("#cartScrim"), cartBody = $("#cartBody"), cartCount = $("#cartCount"), cartSubtotal = $("#cartSubtotal");
  const openCart = () => { cartDrawer && cartDrawer.classList.add("open"); cartScrim && cartScrim.classList.add("open"); document.body.style.overflow = "hidden"; };
  const closeCart = () => { cartDrawer && cartDrawer.classList.remove("open"); cartScrim && cartScrim.classList.remove("open"); document.body.style.overflow = ""; };
  $("#openCart")?.addEventListener("click", async () => { await refreshCart(); openCart(); });
  $("#closeCart")?.addEventListener("click", closeCart);
  cartScrim?.addEventListener("click", closeCart);

  async function getCart() {
    const r = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
    const c = await r.json(); CURRENCY = c.currency || CURRENCY; return c;
  }
  async function addItems(items) {
    const r = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items }) });
    if (!r.ok) { showToast(I18N.add_failed || "Sorry, couldn't add that item"); return null; }
    return r.json();
  }
  async function changeLine(key, quantity) {
    await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ id: key, quantity }) });
  }

  async function refreshCart() { renderCart(await getCart()); }

  function renderCart(cart) {
    if (cartCount) { cartCount.textContent = cart.item_count; cartCount.style.display = cart.item_count ? "grid" : "none"; }
    if (!cartBody) return;
    if (!cart.item_count) {
      cartBody.innerHTML = `<div class="cart-empty"><p>${I18N.cart_empty || "Your cart is empty."}</p></div>`;
      if (cartSubtotal) cartSubtotal.textContent = money(0);
      return;
    }
    const remaining = Math.max(0, FREE_SHIP - cart.total_price);
    const pct = Math.min(100, (cart.total_price / FREE_SHIP) * 100);
    let html = `<div class="ship-bar"><div class="ship-bar__txt">${ic("truck")}${remaining > 0 ? (I18N.ship_more || "Add {amt} for FREE shipping").replace("{amt}", `<b>${money(remaining)}</b>`) : (I18N.ship_unlocked || "You've unlocked <b>FREE shipping</b>")}</div><div class="ship-bar__track"><div class="ship-bar__fill" style="width:${pct}%"></div></div></div>`;
    cart.items.forEach((l) => {
      const img = l.image ? `<img src="${l.image.replace(/(\.[a-z]+)(\?.*)?$/i, "_120x$1$2")}" alt="" style="width:64px;height:64px;border-radius:10px;object-fit:cover">` : `<div class="cart-line__img">${ic("bone")}</div>`;
      const plan = l.selling_plan_allocation ? (I18N.sub_prefix || "Subscribe & Save · ") : (I18N.one_prefix || "One time · ");
      html += `<div class="cart-line">${img}<div><div class="cart-line__t">${l.product_title}</div><div class="cart-line__s">${plan}${I18N.qty || "Qty"} ${l.quantity}</div><button class="cart-line__s" style="color:var(--clay-deep);text-decoration:underline;margin-top:4px" data-remove="${l.key}">${I18N.remove || "Remove"}</button></div><div class="cart-line__price">${money(l.final_line_price)}</div></div>`;
    });
    html += `<div id="cartRecs"></div>`;
    cartBody.innerHTML = html;
    if (cartSubtotal) cartSubtotal.textContent = money(cart.total_price);
    $$("[data-remove]", cartBody).forEach((b) => b.addEventListener("click", async () => { await changeLine(b.dataset.remove, 0); refreshCart(); }));
    loadRecs(cart);
  }

  /* "Often added together" — Shopify's related-products engine first, then a
     curated deterministic fallback so the slot is never empty on a new store. */
  async function loadRecs(cart) {
    const host = $("#cartRecs"); if (!host || !cart.items.length) return;
    const inCart = new Set(cart.items.map((i) => i.product_id));
    const pid = cart.items[0].product_id;
    let recs = [];
    // 1) native related-products engine (best once there's order history)
    try {
      const r = await fetch(`/recommendations/products.json?product_id=${pid}&limit=4&intent=related`);
      const data = await r.json();
      recs = (data.products || []).filter((p) => p.available && !inCart.has(p.id)).map((p) => {
        const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0];
        return v ? { variantId: v.id, title: p.title, price: p.price, img: p.featured_image || "" } : null;
      }).filter(Boolean).slice(0, 2);
    } catch (e) { /* fall through to the curated fallback */ }
    // 2) curated fallback from the pairing map (cold-start: no recs data yet)
    if (!recs.length) {
      recs = (PAIRS[pid] || []).filter((c) => c.available && !inCart.has(c.id)).slice(0, 2)
        .map((c) => ({ variantId: c.variantId, title: c.title, price: c.price, img: c.img }));
    }
    if (!recs.length) return;
    let h = `<div class="cart-rec"><div class="cart-rec__head">${I18N.rec_head || "Often added together · in stock"}</div>`;
    recs.forEach((p) => {
      const img = p.img ? `<img src="${p.img}" alt="" style="width:48px;height:48px;border-radius:8px;object-fit:cover">` : `<div class="rec-line__img">${ic("paw")}</div>`;
      h += `<div class="rec-line">${img}<div><div class="rec-line__t">${p.title}</div><div class="rec-line__p">${money(p.price)}</div></div><button class="rec-line__add" data-add="${p.variantId}">${I18N.rec_add || "Add"}</button></div>`;
    });
    h += `</div>`;
    host.innerHTML = h;
    $$("[data-add]", host).forEach((b) => b.addEventListener("click", async () => {
      if (adding) return; adding = true;
      try { await addItems([{ id: b.dataset.add, quantity: 1 }]); await refreshCart(); showToast(I18N.added || "Added to cart"); }
      finally { adding = false; }
    }));
  }

  /* ---------- POST-ADD UPSELL ----------
     contextual upsell: show the complement of the product just added. `pid` is the
     adding box's own product id (resolved per instance in initBuyBox → addMain). */
  function showUpsell(pid, cart) {
    const modal = $("#upsellModal");
    const inCart = new Set(cart.items.map((i) => i.product_id));
    const comp = (PAIRS[pid] || []).find((c) => c.available && !inCart.has(c.id));
    if (!modal || !comp) { openCart(); return; }
    modal.dataset.upsellVariant = comp.variantId;
    const imgEl = $("#upsellImg");
    if (imgEl) imgEl.innerHTML = comp.img ? `<img src="${comp.img}" alt="${comp.title}" style="width:100%;height:100%;object-fit:cover;border-radius:10px">` : ic("paw");
    const t = $("#upsellTitle"); if (t) t.textContent = comp.title;
    const p = $("#upsellPitch"); if (p) p.textContent = comp.pitch || I18N.upsell_pitch || "A natural pairing for what's in your cart.";
    const pr = $("#upsellPrice"); if (pr) pr.innerHTML = money(comp.price);
    const ab = $("#upsellAdd"); if (ab) ab.textContent = (I18N.upsell_yes || "Yes, add for {amt}").replace("{amt}", money(comp.price));
    modal.classList.add("open");
  }

  /* upsell accept */
  $("#upsellAdd")?.addEventListener("click", async () => {
    const upsell = $("#upsellModal");
    if (!upsell || !upsell.dataset.upsellVariant || adding) return;
    adding = true;
    try {
      await addItems([{ id: upsell.dataset.upsellVariant, quantity: 1 }]);
      upsell.classList.remove("open");
      await refreshCart(); showToast(I18N.added || "Added to cart"); openCart();
    } finally { adding = false; }
  });

  /* ---------- EMAIL CAPTURE (Shopify native customer list) ----------
     Posts to Shopify's storefront customer form so the email is saved to
     Admin → Customers (subscribed to email marketing) and tagged by source.
     Upgrade path: swap this for Klaviyo to capture per-product properties
     and trigger back-in-stock / welcome flows (see GO-LIVE.md). */
  async function subscribeEmail(email, tags) {
    if (!email) return false;
    /* Klaviyo — EN signups go to "Email List" (XA2ADY, single opt-in), PL signups to
       "Email List PL" (RnDf5Y, double opt-in per GDPR). The language profile property
       drives conditional splits inside the flows. Public site id WDcgJ8 is safe to
       expose client-side. Fire-and-forget (don't block UX). */
    var lang = (document.documentElement.lang || "en").toLowerCase().slice(0, 2) === "pl" ? "pl" : "en";
    var listId = lang === "pl" ? "RnDf5Y" : "XA2ADY";
    try {
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=WDcgJ8", {
        method: "POST",
        headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
        body: JSON.stringify({ data: { type: "subscription", attributes: { custom_source: tags || "Website signup", profile: { data: { type: "profile", attributes: { email: email, properties: { language: lang } } } } }, relationships: { list: { data: { type: "list", id: listId } } } } })
      }).catch(function () {});
    } catch (e) {}
    /* Shopify native customer list (unchanged) */
    try {
      await fetch("/contact", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
        body: new URLSearchParams({ form_type: "customer", utf8: "✓", "contact[email]": email, "contact[tags]": (tags ? tags + ", " : "") + "lang-" + lang })
      });
      return true;
    } catch (e) { return false; }
  }

  /* ---------- WAITLIST ---------- */
  const waitlistModal = $("#waitlistModal");
  let currentWaitlist = "";
  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-waitlist]");
    if (t) { e.preventDefault(); closeMenu(); currentWaitlist = t.dataset.waitlist;
      $("#wlTitle").innerHTML = (I18N.wl_title || "Join the {name} waitlist").replace("{name}", currentWaitlist);
      $("#wlIntro").innerHTML = (I18N.wl_intro || "Be first to know when <strong>{name}</strong> launches, plus a launch day discount.").replace("{name}", currentWaitlist);
      $("#wlFormWrap").classList.remove("hide"); $("#wlSuccess").classList.add("hide"); $("#waitlistForm").reset();
      waitlistModal.classList.add("open");
    }
  });
  $("#waitlistForm")?.addEventListener("submit", (e) => {
    e.preventDefault();
    const email = e.target.email.value.trim(), dog = e.target.dog.value.trim();
    subscribeEmail(email, "waitlist, waitlist-" + currentWaitlist);
    $("#wlFormWrap").classList.add("hide"); $("#wlSuccess").classList.remove("hide");
    $("#wlSuccessMsg").textContent = `We'll email ${email || "you"} the moment ${currentWaitlist} launches.${dog ? " " + dog + " is going to love it." : ""}`;
  });

  /* ---------- EMAIL WELCOME POPUP ---------- */
  const welcome = $("#welcomeModal");
  if (welcome) {
    const seen = () => { try { return sessionStorage.getItem("welcomeSeen") === "1"; } catch (_) { return false; } };
    const mark = () => { try { sessionStorage.setItem("welcomeSeen", "1"); } catch (_) {} };
    const show = () => { if (seen() || $$(".modal.open").length || (cartDrawer && cartDrawer.classList.contains("open"))) return; welcome.classList.add("open"); mark(); };
    const timer = setTimeout(show, window.innerWidth < 768 ? 12000 : 7000);
    document.addEventListener("mouseout", (e) => { if (e.clientY <= 0) { clearTimeout(timer); show(); } });
    $("#welcomeForm")?.addEventListener("submit", (e) => {
      e.preventDefault();
      const input = e.target.querySelector('input[type="email"]');
      subscribeEmail(input ? input.value.trim() : "", "welcome-popup, newsletter");
      welcome.querySelector("#welcomeFormWrap").classList.add("hide");
      welcome.querySelector("#welcomeSuccess").classList.remove("hide");
    });
  }

  /* ---------- MODAL CLOSE / ESC ---------- */
  document.addEventListener("click", (e) => { if (e.target.closest("[data-close-modal]")) e.target.closest(".modal").classList.remove("open"); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") { $$(".modal.open").forEach((m) => m.classList.remove("open")); closeCart(); closeMenu(); } });

  /* ---------- FAQ ---------- */
  $$(".faq__q").forEach((q) => q.addEventListener("click", () => {
    const item = q.parentElement, a = q.nextElementSibling;
    const open = item.classList.toggle("open");
    a.style.maxHeight = open ? a.scrollHeight + 40 + "px" : null;
  }));

  /* ---------- NEWSLETTER (footer/blog inline) ---------- */
  $("#newsForm")?.addEventListener("submit", (e) => {
    e.preventDefault();
    const input = e.target.querySelector('input[type="email"]');
    subscribeEmail(input ? input.value.trim() : "", "newsletter");
    e.target.reset();
    showToast(I18N.signup_done || "You're in. Check your inbox for your code");
  });

  /* Sticky mobile ATC is handled per-product by snippets/sticky-atc.liquid (.satc) — self-contained. */

  /* ---------- TOAST ---------- */
  let toastTimer;
  function showToast(msg) { const t = $("#toast"); if (!t) return; t.textContent = msg; t.classList.add("show"); clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove("show"), 2600); }

  /* init cart count on load */
  getCart().then(renderCart).catch(() => {});
})();
